import * as types from "../constants";

const initialState = {
  items: [],
  selectItem:{
    category: "",
    attributes: []
  },
  switch: false,
};

export default function reducer(state = initialState, actions) {
  const { type, payload } = actions;

  switch (type) {
    case types.GET_ITEMS:
    case types.GET_REPORT:
      return {
        ...state,
        items: payload
      }
    case types.SELECT_ITEM:
      return {
        ...state,
        selectItem: payload,
        switch: true,
      }
    case types.SEND_ITEM_NOTE:
        return{
          ...state,
          selectItem: {
            ...state.selectItem,
            notes: payload
          }
        }
    case types.EDIT_ITEM_NOTE:
      return{
        ...state,
        selectItem: {
          ...state.selectItem,
          attributes: {
            ...state.selectItem.attributes,
            [payload.name]: payload.value
          }
        }
      }
    case types.CREATE_NEW_ITEM:
      state.items.push(payload)
      return {
        ...state
      }

    default:
      return state;
  }
}
